import axios from "axios";
import { JobApplication } from "../../api-types/job-applications";
import { JOB_APPLICATIONS_URL } from "../utils";

export const fetchJobApplications = () => {
  return axios.get<JobApplication[]>(JOB_APPLICATIONS_URL);
};
